module.exports = __webpack_public_path__ + "media/images/icons/quote-f018c4171c62d19d35fd4fe79fbe6d0f.svg";